var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9362_48389",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9362_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2456 9C13.4569 9 13.6354 8.92854 13.7812 8.78563C13.9271 8.64271 14 8.46563 14 8.25438C14 8.04313 13.9285 7.86458 13.7856 7.71875C13.6427 7.57292 13.4656 7.5 13.2544 7.5C13.0431 7.5 12.8646 7.57146 12.7188 7.71437C12.5729 7.85729 12.5 8.03437 12.5 8.24562C12.5 8.45687 12.5715 8.63542 12.7144 8.78125C12.8573 8.92708 13.0344 9 13.2456 9ZM7 7.5H11V6H7V7.5ZM4 17C3.55556 15.2778 3.11111 13.7014 2.66667 12.2708C2.22222 10.8403 2 9.41667 2 8C2 6.74542 2.43639 5.68181 3.30917 4.80917C4.18181 3.93639 5.24542 3.5 6.5 3.5H10.6458C11.0625 3.01389 11.5625 2.64236 12.1458 2.38542C12.7292 2.12847 13.3472 2 14 2C14.2778 2 14.5139 2.09722 14.7083 2.29167C14.9028 2.48611 15 2.72222 15 3C15 3.11111 14.9861 3.22222 14.9583 3.33333C14.9306 3.44444 14.8889 3.55556 14.8333 3.66667C14.7639 3.80556 14.6979 3.94097 14.6354 4.07292C14.5729 4.20486 14.5278 4.34722 14.5 4.5L16.5 6.5H18V12L15.75 12.5L14.5 17H10V15.5H8.5V17H4ZM5.125 15.5H7V14H11.5V15.5H13.3542L14.5417 11.2292L16.5 10.7917V8H15.875L13 5.125C13 4.85819 13.0174 4.60139 13.0521 4.35458C13.0868 4.10778 13.1389 3.85764 13.2083 3.60417C12.8472 3.71528 12.5104 3.88194 12.1979 4.10417C11.8854 4.32639 11.6181 4.625 11.3958 5H6.5C5.67139 5 4.96424 5.29285 4.37854 5.87854C3.79285 6.46424 3.5 7.17139 3.5 8C3.5 9.15278 3.68403 10.3438 4.05208 11.5729C4.42014 12.8021 4.77778 14.1111 5.125 15.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavings);
export default __webpack_public_path__ + "static/media/savings.56731d3d9a522523f35187550641ffd5.svg";
export { ForwardRef as ReactComponent };